// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b8e08b4c","396":"207ec429","455":"fa60dec6","977":"2e58827f"}[chunkId] + ".chunk.js";
};